// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"sca-z","narrowOptionButtons":"tca-z","noOptions":"uca-z"};